import { useCallback } from 'react';

import { useUiActions } from 'src/store';
import { usePopups } from '../services';
import { PROJECT_BRAND_VOICE_SELECTION_POPUP } from '../types';

export const useProjectBrandVoicesSelectionPopup = () => {
  const popups = usePopups();
  const uiActions = useUiActions();

  return useCallback(
    ({
      currentBrandVoice,
      brandVoices,
      generationTool,
      type,
      origin,
      onSubmit,
      onUpdatedCallback,
    }) => {
      uiActions.increaseLocalPopupVisibleCount();
      popups.openPopup(PROJECT_BRAND_VOICE_SELECTION_POPUP, {
        onClose: () => {
          popups.closePopup(PROJECT_BRAND_VOICE_SELECTION_POPUP);
          uiActions.decreaseLocalPopupVisibleCount();
        },
        onSubmit,
        currentBrandVoice,
        brandVoices,
        generationTool,
        type,
        origin,
        onUpdatedCallback,
      });
    },
    [popups, uiActions]
  );
};
